/* global axios */
import Auth from '../api/auth';
import {VUE_APP_API_FLOWS_BASE_URL } from '../../config/index'
import {VUE_APP_API_CAMPAINGS_BASE_URL} from '../../config/index'


const DEFAULT_API_VERSION = 'v1';

class ApiNotifai {
  constructor(resource, options = {}) {
    this.apiVersion = `/api/${options.apiVersion || DEFAULT_API_VERSION}`;
    this.options = options;
    this.resource = resource;
  }

  get url() {
    return `${this.baseUrl()}/${this.resource}`;
  }

  // eslint-disable-next-line class-methods-use-this
  get accountIdFromRoute() {
    const isInsideAccountScopedURLs =
      window.location.pathname.includes('/app/accounts');

    if (isInsideAccountScopedURLs) {
      return window.location.pathname.split('/')[3];
    }

    return '';
  }

  baseUrl() {
  let  url =VUE_APP_API_FLOWS_BASE_URL;
    /*
    if (this.options.accountScoped && this.accountIdFromRoute) {
      url = `${url}/accounts/${this.accountIdFromRoute}/flow-manager`;
    }*/
     return url;
  }


  baseFlowsUrl() {
    let url =VUE_APP_API_FLOWS_BASE_URL;
     return url;
  }

  
  baseCampaingUrl() {
    let url = VUE_APP_API_CAMPAINGS_BASE_URL;
    return url;
   }
 

  get(params) {
    return axios.get(this.baseFlowsUrl()+"/accounts/"+this.accountIdFromRoute+"/flow-manager/flows",{
      params:params/*,
      headers: {
      'Content-Type': 'application/json',
        'access-token': "KxqyoQW16XX3Imn9OZBiXA",
        'token-type': "Bearer",
        'client': "7oy0cu8Vf_F7PTcNz9ZF7A",
        'expiry': 1744386126,
        'uid': "jjvasquezcabos@gmail.com",
      }*/
    });
  }


  getAll(params) {
    return axios.get(this.baseFlowsUrl()+"/accounts/"+this.accountIdFromRoute+"/flow-manager/flows",{
      params:params/*,
      headers: {
      'Content-Type': 'application/json',
        'access-token': "KxqyoQW16XX3Imn9OZBiXA",
        'token-type': "Bearer",
        'client': "7oy0cu8Vf_F7PTcNz9ZF7A",
        'expiry': 1748691472,
        'uid': "jjvasquezcabos@gmail.com",
      }*/
    });
  }


  show(id) {
    return axios.get(this.baseFlowsUrl()+"/accounts/"+this.accountIdFromRoute+"/flow-manager/flows/1234/auth");
  }

  getTypeBotToken(){
    return axios.get(this.baseFlowsUrl()+"/accounts/"+this.accountIdFromRoute+"/flow-manager/flows/1234/auth");
  }

  create(data) {
    return axios.post(this.baseFlowsUrl()+"/accounts/"+this.accountIdFromRoute+"/flow-manager/flows", data);
  }


  clone(data) {
    return axios.post(this.baseFlowsUrl()+"/accounts/"+this.accountIdFromRoute+"/flow-manager/flows/clone", data/*, {
     
      headers: {
      'Content-Type': 'application/json',
        'access-token': "KxqyoQW16XX3Imn9OZBiXA",
        'token-type': "Bearer",
        'client': "7oy0cu8Vf_F7PTcNz9ZF7A",
        'expiry': 1748691472,
        'uid': "jjvasquezcabos@gmail.com",
      }
    }*/);
  }

  publish(flowId) {
    return axios.post(this.baseFlowsUrl()+"/accounts/"+this.accountIdFromRoute+"/flow-manager/flows/"+flowId+"/publish",{status:1});
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(flowId) {
    return axios.delete(this.baseFlowsUrl()+`/accounts/${this.accountIdFromRoute}/flow-manager/flows/${flowId}`);
  }
}

export default ApiNotifai;
